/**
 * When the SPA runs on `{slug}.localhost` but the API base URL targets `localhost` / `127.0.0.1`,
 * the API never sees the UI hostname in `Host`. The client sends `X-Tv-Dev-App-Host` so tenant
 * middleware can resolve the slug (API must have ENABLE_LOCAL_TENANT_HOSTS=true).
 */
export const TV_DEV_APP_HOST_HEADER = "X-Tv-Dev-App-Host";

/**
 * When the SPA runs on a tenant hostname (e.g. `icici.stage.trustvid.ai`) but `REACT_APP_API_URL`
 * points at a separate global API host (e.g. `https://stgapi.trustvid.ai`), the client sends this
 * header so tenant middleware can resolve the tenant. The API only trusts it when it matches
 * the request `Origin` / `Referer` hostname.
 */
export const TV_TENANT_APP_HOST_HEADER = "X-Tv-Tenant-App-Host";

const LOCAL_TENANT_UI_HOST = /^[a-z0-9-]+\.localhost$/i;

const parseApiHostname = (apiUrl) => {
  const match = /^https?:\/\/([^/:?#]+)/i.exec(String(apiUrl).trim());
  return match ? match[1].toLowerCase() : "";
};

export function shouldAttachLocalDevTenantHostHeader(apiUrl, windowHostname) {
  if (!apiUrl || !windowHostname) {
    return false;
  }
  if (!LOCAL_TENANT_UI_HOST.test(windowHostname)) {
    return false;
  }
  const h = parseApiHostname(apiUrl);
  return h === "localhost" || h === "127.0.0.1";
}

/**
 * @returns {boolean} true when the UI origin host differs from the API base URL host (cross-origin API).
 */
export function shouldAttachCrossOriginTenantAppHostHeader(apiUrl, windowHostname) {
  if (!apiUrl || !windowHostname) {
    return false;
  }
  if (shouldAttachLocalDevTenantHostHeader(apiUrl, windowHostname)) {
    return false;
  }
  const apiHost = parseApiHostname(apiUrl);
  if (!apiHost) {
    return false;
  }
  return apiHost !== String(windowHostname).toLowerCase();
}
